// @flow

import { interpolate } from "diskho";

export default class Translation {
  translations: Object;

  constructor(data: Object) {
    this.translations = data;
  }

  translateFallback(key: string, reason: string): string {
    if (process.env.NODE_ENV !== "production") {
      console.error(`Translate: "${key}" key is ${reason}`);
      return `[${key}]`;
    }

    return "";
  }

  translate(key: string, args: Object = {}): string {
    const path = key.split(".");
    let   data = this.translations;

    for (let i = 0; i < path.length; i++) {
      if (typeof data !== "object" || ! (path[i] in data)) {
        return this.translateFallback(key, "missing");
      }

      data = data[path[i]];
    }

    if (!data || typeof data !== "string") {
      if (process.env.NODE_ENV !== "production") {
        console.warn(`Translate: "${key}" is not a string.`);

        return `[${key}]`;
      }

      return "";
    }

    return interpolate(data, args, key);
  }

  hasTranslation(key: string, args: Object = {}): string {
    const path = key.split(".");
    let   data = this.translations;

    for (let i = 0; i < path.length; i++) {
      if (typeof data !== "object" || ! (path[i] in data)) {
        return false;
      }

      data = data[path[i]];
    }

    if (!data || typeof data !== "string") {
      return false;
    }

    return true;
  }

  get(key: string): any {
    return this.translations[key];
  }
}
